import React from "react";
import { Alert } from "antd";

const Error = ({ error, message }) => {
	return (
		<div className="error-container">
			<Alert
				message={error}
				description={message}
				type="error"
				showIcon
			/>
		</div>
	);
};

export default Error;
